// First we import components from our components folder
import React from 'react';

export default function Resume() {
  return (
    
    <div className='containerMain'>
      <h1>Resume</h1>
      <p>
        Coming soon!
      </p>
    </div>
  );
}
